import { render, staticRenderFns } from "./task_tabs_details.vue?vue&type=template&id=42ac2654&scoped=true&"
import script from "./task_tabs_details.vue?vue&type=script&lang=js&"
export * from "./task_tabs_details.vue?vue&type=script&lang=js&"
import style0 from "./task_tabs_details.vue?vue&type=style&index=0&id=42ac2654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ac2654",
  null
  
)

export default component.exports